import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { catchError, from, Observable, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { IAuctionDTO } from '../../../models/IAuctionsDTO';

@Injectable({
  providedIn: 'root'
})
export class MyAuctionsService {

  private httpService = inject(CommonHttpService);
  private oidcSecurityService = inject(OidcSecurityService);
  private http = inject(HttpClient);


  myAuctionsListSignal = signal<IAuctionDTO[] | null>(null);

  constructor() { }

  public getMyAuctions(): Observable<IAuctionDTO[]> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/auctions`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {

        if (authResult.isAuthenticated) {
          let headers = new HttpHeaders();
          headers = headers.set('Authorization', `Bearer ${authResult.accessToken}`);

          return this.httpService.get<IAuctionDTO[]>(url, undefined, headers);
        } else {
          return throwError(() => new Error('User is not authenticated'));
        }
      }),
      tap(response => {
        this.myAuctionsListSignal.set(response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  deleteAuction(itemId: number): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/auctions/${itemId}`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');
          return this.httpService.delete<string>(url, null, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      })
    );
  }

  putMyAuction(auctionId: number): Observable<string> {
    const url = `${environment.apiUrl}/v3/accounts/my-account/auctions/${auctionId}`;

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.httpService.put<string>(url, null, undefined, headers);
        } else {
          return throwError(() => new Error('unauthenticated user or expired token'));
        }
      })
    );
  }


}


